'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Price component for prices translations.
                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withTranslator = require('./withTranslator');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Price = (_dec = (0, _withTranslator.withTranslator)({ propsNamespace: 'translator' }), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Price, _React$Component);

  function Price() {
    (0, _classCallCheck3.default)(this, Price);
    return (0, _possibleConstructorReturn3.default)(this, (Price.__proto__ || (0, _getPrototypeOf2.default)(Price)).apply(this, arguments));
  }

  (0, _createClass3.default)(Price, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          translator = _props.translator,
          currency = _props.currency,
          children = _props.children,
          extraProps = (0, _objectWithoutProperties3.default)(_props, ['translator', 'currency', 'children']);


      return _react2.default.createElement(
        'span',
        extraProps,
        translator.formatPrice(children, currency)
      );
    }
  }]);
  return Price;
}(_react2.default.Component), _class2.propTypes = {
  // imported by @withTranslator
  translator: _propTypes2.default.object,
  // user attributes
  currency: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.any.isRequired
}, _temp)) || _class);
exports.default = Price;


//////////////////
// WEBPACK FOOTER
// ./~/@gandi/react-translate/dist/react/Price.js
// module id = 512
// module chunks = 0